import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconMale$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMale extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1a87720afd7ac0935a821ee0811eadec2b35d884', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f1b2190b16b2e34e1da5eb2e1dcf9eebe808d265', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'f9104267dd550f7db484426e0d327fc7b8268132', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.5 4h-6c-.3 0-.5.2-.5.5V5c0 .3.2.5.5.5h3.9l-4.1 4.1C10.6 9.2 9.8 9 9 9c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5c0-1.3-.5-2.6-1.4-3.5l3.9-3.9v3.9c0 .3.2.5.5.5h.5c.3 0 .5-.2.5-.5v-6c0-.3-.2-.5-.5-.5M9 17.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-male", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-male"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-male":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMale$1);
            }
            break;
    } });
}

const CosmosIconMale = CosmosIconMale$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMale, defineCustomElement };
